import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
}from 'react-router-dom';
import Artist from './pages/Artist';
import Home from "./pages/Home";
import Register from "./components/Register";
import Login from './components/Login';

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path="//" component={Home}></Route>
        <Route path="/artist/:artistName" component={Artist}></Route>
        <Route path="/join" component={Register}></Route>
        <Route path="/signin" component={Login}></Route>
      </Switch>
    </Router>
  );
};

export default App;